import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { Cordwood } from "../../../types/models/Cordwood";
import CordwoodHistoryListItem from "../../../../timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: Cordwood;
};

const CordwoodTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'cordwoodHistory');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="Cordwood-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/CordwoodHistories/list/view') &&
                    <Tab label={t`Cordwood Histories`} value="cordwoodHistory"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/timber/entities/CordwoodHistories/list/view') &&
                <TabPanel value={tabValue} index="cordwoodHistory" data-testid="CordwoodHistory-tab">
                    <CordwoodHistoryListItem cordwoodId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default CordwoodTabs;
